export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Id комментария
  //--------------------------------------------------------------------------
  comment: {
    type: Object,
    required: true,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                        Контекст комментариев
  //--------------------------------------------------------------------------
  commentsPlace: {
    type: String,
    required: true
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});
